import React from "react";

const Error = () => {
  return (
    <section className="_404">
      <h3 className="_404__title">404</h3>
      <h4 className="_404__subtitle">Page Not Found</h4>
    </section>
  );
};

export default Error;
